import { NgModule } from '@angular/core';
//import { CustomDateAdapter } from '../custom-date-adapter';
import { 
  MatCardModule,
  MatButtonModule,
  MatInputModule, 
  MatListModule, 
  MatGridListModule,
  MatToolbarModule,
  MatIconModule,
  MatSidenavModule,
  MatTabsModule,
  MatExpansionModule,
  MatSelectModule,
  MatCheckboxModule,
  MatSortModule,
  MatTableModule,
  MatDialogModule,
  MatButtonToggleModule,
  MatTooltipModule,
  MatSliderModule,
  MatProgressSpinnerModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatSnackBarModule,
  } from '@angular/material';

@NgModule({
  imports: [
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatListModule,
    MatGridListModule,
    MatToolbarModule,
    MatIconModule,
    MatSidenavModule,
    MatTabsModule,
    MatExpansionModule,
    MatSelectModule,
    MatCheckboxModule,
    MatSortModule,
    MatTableModule,
    MatDialogModule,
    MatButtonToggleModule,
    MatTooltipModule,
    MatSliderModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSnackBarModule,
    
  ],
  exports: [
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatListModule,
    MatGridListModule,
    MatToolbarModule,
    MatIconModule,
    MatSidenavModule,
    MatTabsModule,
    MatExpansionModule,
    MatSelectModule,
    MatCheckboxModule,
    MatSortModule,
    MatTableModule,
    MatDialogModule,
    MatButtonToggleModule,
    MatTooltipModule,
    MatSliderModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSnackBarModule,
  ]
})
export class MaterialModule { }



// WEBPACK FOOTER //
// ./src/app/material/material.module.ts